module.exports = __webpack_public_path__ + "static/media/mappamolsa.deb213e9.webp";